import React, { useState, useEffect } from 'react';
import { getUser } from '../../../utils/Common';
import VainillaDialog from '../../sharecomponents/vanilladialog';
import v from '../../../utils/Verifiers.jsx';
import { forEach } from 'lodash';
import AgregarOrdenesTrabajo from './ordenesTrabajoComponents/AgregarOrdenesTrabajo';
import etiqImg from '../../../assets/etiqueta.png';
import scanner from '../../../assets/barcodeScanner.png';
import EtiiquetasBarCodePDF from '../../templates/EtiiquetasBarCodePDF.jsx';
import EscanerBarcodeActividades from '../../sharecomponents/EscanerBarcodeActividades.jsx';
import ReportesOrdenesTrabajo from './ordenesTrabajoComponents/ReportesOrdenesTrabajo.jsx';
import SyncNominaUsersButton from '../../../utils/SyncNominaUsersButton.jsx';
import OrdenesTrabajoOperativo from './OrdenesTrabajoOperativo.jsx';
import OrdenesTrabajoInferidas from './OrdenesTrabajoInferidas.jsx';

const OrdenesTrabajoSiembra = () => {
    const [abrirEditor, setabrirEditor] = useState(false);
    const [semanas, setsemanas] = useState([]);
    const [planes, setplanes] = useState([]);
    const perfil = (getUser()?.perfil?.nombre ?? '').toUpperCase();
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [payload, setpayload] = useState({ semana: "" });
    const [diasDetallesSelecciones, setdiasDetallesSelecciones] = useState({});
    const [generadorEtiqeustas, setgeneradorEtiqeustas] = useState(false);
    const [escanarAvance, setescanarAvance] = useState(false);
    const [openReports, setopenReports] = useState({ show: false, semanas: [], semana: "" });
    const dias = ['todos', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const [tipoOrden, settipoOrden] = useState('ORDENES DE TRABAJO - SIEMBRA');


    useEffect(() => {
        getOrdenes();
        getNombresLaboradores();
        /*setTimeout(() => {
            setabrirEditor({ plan_siembra: 0 });
        }, 700);*/
    }, []);

    const divisor = (key) => (<div className='w-100' key={key} />);

    /**
     * Obtiene la lista de ordenes de una detrminada semana, si se actualiza la semana se debe enviar la semana a consultar en el payload
     * Esta función actualiza  el payload, las semanas, las ordenes y los planes
     * @param {object} pay carga util para enviar al servidor
     * @returns 
     */
    const getOrdenes = async (pay = { ...payload }) => {
        let resp = await v.getDataAPI('/ordenes_trabajo/siembra/get', pay, setloader, setdialog);
        if (!resp) return;
        pay.semana = resp.data.semana;
        v.saveLS("semana_orden_siembra", resp.data.semana);
        setpayload(pay);
        actualizarOrdenes(resp.data);
    }

    /**
     * Recibe la carga util de una respuesta de api de ordenes de trabajo y actualiza las semanas y planes
     * @param {object} data 
     */
    const actualizarOrdenes = (data) => {
        setsemanas(data.semanas);
        setplanes(data.planes);
        v.saveLS('planes_trabajo', data.planes);
        v.saveLS('usuarios_asistencias', data.usuarios_asistencias);
    }

    /**
     * Obtiene la lista de usuarios que pueden recibir asignaciones y actualiza el localstorage para que estén diponible al abrir la sección
     * @returns {void}
     */
    const getNombresLaboradores = async () => {
        if (perfil === 'EJECUCION DE LABORES') return;
        let resp = await v.getDataAPI('/ordenes_trabajo/usuarios', { ...payload }, false, setdialog);
        if (!resp.estatus) return;
        v.saveLS('usuarios_labores', resp.data);
    }

    const botonGeneraretiquetas = (data, size = "big") => {
        if (perfil === 'EJECUCION DE LABORES') return;
        if (size == "big") {
            return (<div className='col-auto contenedor mb-2'>
                <div className='w-100 m-0 p-0 bg-white ps-2 pe-2 shadow contenedor bw-200 border border-2 border-warning pointer multishadow-sm round-xxl text-bold'
                    onClick={() => {
                        v.saveLS('impresor_etiquetas', data);
                        setgeneradorEtiqeustas(true);
                    }}
                    style={{ height: '24px' }}>
                    Impresión general de etiquetas<img src={etiqImg} style={{ height: "20px", width: "auto" }} className='ms-2' />
                </div>
            </div>)
        }

        let sizes = { width: size == 'small' ? '30px' : '50px', height: size == 'small' ? '15px' : '25px' }
        return (
            <div style={sizes}
                className='m-0 p-0 bg-white shadow contenedor border  border-warning pointer scale-025 round-xxl text-bold'
                onClick={() => {
                    v.saveLS('impresor_etiquetas', data);
                    setgeneradorEtiqeustas(true);
                }}
            >
                <img src={etiqImg} style={{ height: size == 'small' ? '15px' : '25px', width: "auto" }} />
            </div>
        )
    }

    const contenedorPlan = (plan, i) => {
        let container = (title, value) => (
            <div className="border-bottom text-center" style={{ width: '170px' }}>
                <span className='text-m'>{title}</span>
                <span className='text-bold ps-1 text-m'>{value}</span>
            </div>
        );

        return (
            <>
                <div className='bw-1200 round-xs shadow-multi-sm bg-white border p-1 mb-3' key={v.keyGen()}>
                    <div className='row justify-content-around w-100 m-0 p-0'>
                        <div className='bw-350 text-m text-bold'>{plan.bloque}</div>
                        {container('Plan siembra:', plan.charolas_total)}
                        {container('Plan X día:', plan.total_planeado)}
                        {container('Asignado:', plan.total_asignado)}
                        {container('Realizado:', plan.total_realizado)}
                        <div
                            style={{ width: '60px' }}
                            className='bg-warning round-xxl text-bold shadow border pointer sclale-025 contenedor'
                            onClick={() => setabrirEditor({ plan_siembra: i })}>
                            Editor
                        </div>
                        {botonGeneraretiquetas(
                            {
                                semana: payload.semana,
                                plan_cosecha_id: plan.plan_cosecha_id,
                                dia: diasDetallesSelecciones[plan.plan_cosecha_id],
                                asignado_a: null, id: null
                            },
                            'medium'
                        )}

                        {divisor(v.keyGen())}
                        {contenedorDias(plan.plan_cosecha_id, plan)}
                    </div>
                </div>
                {divisor(v.keyGen())}
            </>
        )
    }

    const filtrarOrdenes = (dia, ordenes) => {
        if (['todos', ''].includes(dia)) return ordenes;
        return ordenes.filter(x => x.dia_nombre === dia);
    }

    const contenedorDias = (id, reg) => {
        let dia_seleccion = diasDetallesSelecciones[id] ?? 'todos';
        let ordenes = filtrarOrdenes(dia_seleccion, reg.ordenes_trabajo.ordenes);
        let len = reg?.ordenes_trabajo?.ordenes?.length ?? 0;
        let contadorOrdenes = { 'todos': len, '': len, 'lunes': 0, 'martes': 0, 'miercoles': 0, 'jueves': 0, 'viernes': 0, 'sabado': 0 };
        forEach(reg.ordenes_trabajo.ordenes, (x) => contadorOrdenes[x.dia_nombre] += 1);

        return (
            <>
                <div className='bw-1000 contenedor p-0 m-0 mt-2 mb-2' key={v.keyGen()}>
                    <div className='row justify-content-around w-100 m-0 p-0'>
                        {dias.map((dia, j) => <div key={v.keyGen()}
                            className={`p-0 border contenedor round-xs mb-1 mt-1 text-s ${dia_seleccion === dia ? 'bg-warning text-bold ' : 'bg-light shadow pointer scale-025'}`}
                            onClick={() => setdiasDetallesSelecciones({ ...diasDetallesSelecciones, [id]: dia })}
                            style={{ width: `${(100 / 7) - 1}%`, minWidth: "75px" }}
                        >{dia.toUpperCase()} <span className='text-s ms-1'>({contadorOrdenes[dia]})</span> </div>)}
                        {divisor()}
                    </div>
                </div>
                <div className='bw-1100 mb-3' key={v.keyGen()}>
                    <div className='row justify-content-around w-100 m-0 p-0'>
                        {contenedorResumenOrdenes(ordenes, dia_seleccion)}
                    </div>
                </div>
            </>

        )
    }

    const contenedorResumenOrdenes = (ordenes, dia) => {
        if (ordenes?.length === 0) return <div className='w-100 text-center text-bold mt-2'>
            <span className='text-300 me-2'>{dia == '' ? 'TODOS' : dia.toUpperCase()}:</span>
            Sin ordenes de trabajo
        </div>;
        return ordenes.map((orden, i) => <div key={v.keyGen()}
            className={`w-100 round-xs mt-2 bg-light multishadow-sm border ${orden.realizado < orden.asignado ? ' text-red3' : 'text-bold'}`}
        >
            <div className='row justify-content-around w-100 m-0 p-0'>
                {['', 'todos'].includes(dia) && <div className='bw-100 text-s text-bold opacity-70 text-center border-bottom border-warning'>{orden.dia_nombre.toUpperCase()}</div>}
                <div className='bw-400 border-bottom'>{orden.asignado_a}</div>
                <div className='bw-200 border-bottom text-bold'>
                    <span className='text-300 me-1'>Asignado:</span>
                    {orden.asignado}
                </div>
                <div className='bw-200 border-bottom text-bold'>
                    <span className='text-300 me-1'>Realizado:</span>
                    {orden.realizado}
                </div>
                {botonGeneraretiquetas(
                    {
                        semana: payload.semana,
                        plan_cosecha_id: orden.plan_cosecha_id,
                        dia: { 0: 'lunes', 1: 'martes', 2: 'miercoles', 3: 'jueves', 4: 'viernes', 5: 'sabado' }[orden.dia],
                        asignado_a: orden.asignado_a_id, id: null
                    },
                    "small"
                )}
            </div>
        </div>
        );

    }

    const semanaSeleccionada = () => {
        let semana = semanas.find(x => x.semana === payload.semana);
        return semana;
    }

    return (
        <div className='vw-100 p-1 m-0 dosis bg-light dosis' style={{ overflow: 'auto' }}>
            <div className="round-xxl p-1 text-bold h5 text-start ps-0 uppercase text-white ps-2 bg-orange-800 m-0 w-100">
                <div className={`row d-flex m-0 p-0 justify-content-between`}>
                    {perfil !== "EJECUCION DE LABORES" && <div className='bw-250 contenedor p-0 m-0'>
                        <div className={`row d-flex m-0 p-0 justify-content-center w-100 lh1`}>
                            <select className='form-control form-control-sm round-xxl shadow-sm p-0 m-0 text-center border-none text-bold pointer' value={tipoOrden} onChange={(e) => settipoOrden(e.target.value)}>
                                <option value='ORDENES DE TRABAJO - SIEMBRA' className='text-bold'>ORDENES DE TRABAJO - SIEMBRA</option>
                                <option value='ORDENES DE TRABAJO - OPERATIVAS' className='text-bold'>ORDENES DE TRABAJO - OPERATIVAS</option>
                                <option value='ORDENES DE TRABAJO - INFERIDAS' className='text-bold'>ORDENES DE TRABAJO - INFERIDAS</option>
                            </select>
                        </div>
                    </div>}
                    {perfil === "EJECUCION DE LABORES" && "ORDENES DE TRABAJO - SIEMBRA"}
                    {perfil !== "EJECUCION DE LABORES" && tipoOrden === 'ORDENES DE TRABAJO - SIEMBRA' && <button className='btn btn-light btn-sm round-xxl shadow bw-100 text-bold p-0' onClick={() => setopenReports({ show: true, semana: payload.semana, semanas })}>Reportes</button>}
                </div>
            </div>
            {tipoOrden === 'ORDENES DE TRABAJO - OPERATIVAS' && <OrdenesTrabajoOperativo />}
            {tipoOrden === 'ORDENES DE TRABAJO - INFERIDAS' && <OrdenesTrabajoInferidas />}
            {tipoOrden === 'ORDENES DE TRABAJO - SIEMBRA' && <>
                <div className='row justify-content-around w-100 m-0 p-0'>

                    <div className='form-group bw-250 mb-2'>
                        <label className='text-bold w-100 text-s ps-2'>Semana</label>
                        <select className='w-100 form-control-sm shadow-sm round-s'
                            value={payload.semana}
                            onChange={(e) => getOrdenes({ ...payload, semana: e.target.value })}>
                            <option value='' >Seleccione una</option>
                            {semanas.map((x, i) => (<option key={i} value={x.semana} >{x.semana} {x.estado === 'completo' ? '' : ' - ' + (x.estado.toUpperCase())}</option>))}
                        </select>
                    </div>
                    <div className='col-auto contenedor mb-2'>
                        <button
                            className='btn btn-warning multishadow-sm round-xxl text-bold pt-0 pb-0 mt-1 mb-1'
                            onClick={() => setabrirEditor({ plan_siembra: -1 })} >
                            Editor general de ordenes
                        </button>
                    </div>
                    {botonGeneraretiquetas({ semana: payload.semana, plan_cosecha_id: null, dia: null, asignado_a: null, id: null }, 'big')}
                    <div className='col-auto contenedor mb-2'>
                        <div className='w-100 m-0 p-0 bg-white ps-2 pe-2 shadow contenedor bw-200 border border-2 border-warning pointer multishadow-sm round-xxl text-bold'
                            onClick={() => {
                                setescanarAvance(true);
                            }}
                            style={{ height: '24px' }}>
                            Reportar avances <img src={scanner} style={{ height: "20px", width: "auto" }} className='ms-2' />
                        </div>
                    </div>
                    {perfil !== "EJECUCION DE LABORES" && <SyncNominaUsersButton />}
                    {divisor(v.keyGen())}
                    <div className='w-100 m-0 p-0' style={{ overflow: "auto", maxHeight: "78vh" }}>
                        <div className='row justify-content-around w-100 m-0 p-0 nowrap'>
                            {planes.length == 0 && semanaSeleccionada() && <div className='w-100 text-center text-bold mt-5 h4 text-300'>No se ha definido el plan de siembra por día de la semana para la semana {payload.semana}</div>}
                            {!semanaSeleccionada() && <div className='w-100 text-center text-bold mt-5 h4 text-300'>Seleccione una semana en control de semanas</div>}
                            {planes.map((plan, i) => <React.Fragment key={v.keyGen()}>{contenedorPlan(plan, i)}</React.Fragment>)}
                        </div>
                    </div>

                </div>
                {openReports.show && <ReportesOrdenesTrabajo semana={openReports.semana} semanas={openReports.semanas} close={() => setopenReports({ show: false, semana: "", semanas: [] })} />}
                {abrirEditor && <AgregarOrdenesTrabajo
                    plan_siembra={abrirEditor.plan_siembra}
                    close={() => {
                        setabrirEditor(false);
                        setplanes(v.getLS('planes_trabajo') ?? []);
                    }} />}
                {generadorEtiqeustas && <EtiiquetasBarCodePDF close={() => {
                    setgeneradorEtiqeustas(false);
                    setplanes(v.getLS('planes_trabajo') ?? []);
                }} />}
                {escanarAvance && <EscanerBarcodeActividades close={() => {
                    setescanarAvance(false);
                    getOrdenes();
                }} />}
                {loader ? ldr : null}
                <VainillaDialog data={dialog} />
            </>}
        </div>
    )
}

export default OrdenesTrabajoSiembra;